import { render, staticRenderFns } from "./CalculationRequestForm.vue?vue&type=template&id=0716ccc9&scoped=true&"
import script from "./CalculationRequestForm.vue?vue&type=script&lang=ts&"
export * from "./CalculationRequestForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716ccc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
